import type { ReactNode } from 'react'

interface ImagesListProps {
	children: ReactNode
}

export const ImagesList = ({ children }: ImagesListProps) => (
	<div className='grid h-full auto-rows-max grid-cols-2 xxl:grid-cols-4 overflow-y-auto xl:grid-cols-3'>
		{children}
	</div>
)

ImagesList.displayName = 'ImagesList'
